import React from 'react'
import Slider from "react-slick"

import { imgUrlConverter } from '../../../../components/utils'
import { URL } from '../../../../constants'
import { SLIDER_SETTINGS } from '../../constants'
import { capitalizeFirstLetter } from '../../utils'
import { PatchesSlide } from './patchesSlide'

export const PatchesSlider = ({
    borderColor,
    imageArray,
    imageSelected,
    newOptionsArray,
    selectedDescription,
    setBorderColor,
    sliderRef,
    subStepSelectedPatch,
    detectTab,
    imgClick,
    field
}) => {
    const patchArray = ['', '__1', '__2', '__3']

    return (
        <Slider {...SLIDER_SETTINGS} ref={sliderRef}>
            {imageArray?.map((individualImage, index) =>
                patchArray.map((item) => {
                    const currentPatchItem = individualImage['PATCH' + item]
                    const currentPatchDescriptionItem = individualImage['DESCRIPTION' + item]

                    const isImageWIthSelectedDescription = currentPatchDescriptionItem.toLowerCase().includes(selectedDescription?.toLowerCase())
                    const isAcceptedPatch = currentPatchItem !== '' && currentPatchItem !== 'Develop new' && currentPatchItem !== 'NA'

                    const onImageFocus = () => detectTab(index, currentPatchItem)
                    const onImageClick = () => imgClick(field, currentPatchItem, currentPatchDescriptionItem)
                    const onKeyDown = (e) => {
                        if (e.keyCode == 32 || e.keyCode == 13) {
                            e.preventDefault()
                            imgClick(field, currentPatchItem, currentPatchDescriptionItem)
                            document.getElementById("goToNextStep").focus({ preventScroll: false })
                        }
                    }

                    if (isAcceptedPatch && isImageWIthSelectedDescription) {
                        let newFilteredArray = newOptionsArray.filter((data) => data.optionOsr === currentPatchItem)
                        const isNewFilteredArrayData = newFilteredArray && newFilteredArray.length && newFilteredArray[0]?.displayName

                        const isImageSelected = currentPatchItem === imageSelected
                        const isSubStepSelectedPatch = currentPatchItem === subStepSelectedPatch

                        const imageTitle = capitalizeFirstLetter(currentPatchDescriptionItem) + ' (' + currentPatchItem + ')'
                        const imageUrl = imgUrlConverter(URL.GENERIC.PATCH_SLIDE_IMAGE(currentPatchItem))
                        const imageAlt = isNewFilteredArrayData
                            ? newFilteredArray[0].displayName
                            : currentPatchDescriptionItem + ' image'

                        const svgClassName = (isImageSelected || isSubStepSelectedPatch)
                            ? "svg-inline--fa fa-check-circle fa-w-16 sliderItemSelectTickShow"
                            : "svg-inline--fa fa-check-circle fa-w-16 sliderItemSelectTickHide"
                        const imageClassName = (isImageSelected || isSubStepSelectedPatch)
                            ? (borderColor || setBorderColor('image-border'))
                            : 'image-default-border'

                        return (
                            <PatchesSlide
                                handleImageClick={onImageClick}
                                handleImageFocus={onImageFocus}
                                handleKeyDown={onKeyDown}
                                id={currentPatchItem}
                                imageAlt={imageAlt}
                                imageClassName={imageClassName}
                                imageKey={currentPatchItem}
                                imageSrc={imageUrl}
                                imageTabIndex={0}
                                imageTitle={imageTitle}
                                svgClassName={svgClassName}
                            />
                        )

                    }
                })
            )}
        </Slider>
    )
}